import { useCreditController } from './useCreditController'
import { FormProvider } from 'react-hook-form'
import CreditBalanceForm from './components/CreditBalanceForm'
import InstallmentsSkeleton from './components/Installments/components/InstallmentsSkeleton'
import Installments from './components/Installments/components'
import ModalStepsFGTS from './components/Installments/components/ModalStepsFGTS'
import { contentModalStepsFGTS } from './components/Installments/components/contentModalStepsFGTS'
import CreditClientForm from './components/CreditClientForm'
import ModalAuthorizeFGTS from './components/Installments/components/ModalAuthorizeFGTS'
import { Logo } from '@/view/components/ui/logo'
import { LeadProvider } from '@/app/contexts/LeadContext'

export default function Credit() {
  const {
    methods,
    handleSubmit,
    isPending,
    result,
    formData,
    showStepsModal,
    currentStep,
    showClientForm,
    handleAuthorizeAdvance,
    handleStepsNext,
    handleStepsPrev,
    handleStepsClose,
    handleRequestCredit,
    handleSimulateInstallment,
    backToInitial,
    showAuthorizeModal,
    handleBackToInstallments,
  } = useCreditController()

  if (isPending) {
    return <InstallmentsSkeleton />
  }

  if (result && formData) {
    if (showClientForm) {
      return (
        <CreditClientForm
          cpf={formData.cpf || ''}
          name={formData.name || ''}
          birthDate={formData.birthDate || ''}
          table={result}
          onBack={handleBackToInstallments}
        />
      )
    }

    return (
      <>
        <Installments
          table={result}
          cpf={formData.cpf || ''}
          name={formData.name || ''}
          onBack={backToInitial}
          onRequestCredit={handleRequestCredit}
          onSimulateInstallment={handleSimulateInstallment}
        />

        <ModalAuthorizeFGTS
          open={showAuthorizeModal}
          onAdvance={handleAuthorizeAdvance}
        />

        <ModalStepsFGTS
          open={showStepsModal}
          steps={contentModalStepsFGTS.steps}
          currentStep={currentStep}
          onNext={handleStepsNext}
          onPrev={handleStepsPrev}
          onClose={handleStepsClose}
        />
      </>
    )
  }

  return (
    <LeadProvider>
      <FormProvider {...methods}>
        <div className="mt-8 flex flex-col items-center justify-center ">
          <div className="h-20">
            <Logo className="h-full object-contain" />
          </div>
          <div className="mt-4">
            <CreditBalanceForm onSubmit={handleSubmit} isPending={isPending} />
          </div>
        </div>
      </FormProvider>
    </LeadProvider>
  )
}
